import { fetchProductsByIds } from '@app/services/productsRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { isEmpty } from 'ramda';

export const PRODUCTS_BY_IDS_QUERY_KEY = 'PRODUCTS_BY_IDS_QUERY_KEY';

export const useProductsByIds = (productIds: string[], buyerId: string | undefined) => {
  const isEnabled = !isEmpty(productIds);

  return useQuery({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => fetchProductsByIds(productIds, buyerId) : skipToken,
    queryKey: [PRODUCTS_BY_IDS_QUERY_KEY, { buyerId, productIds }],
    select: data => productIds.map(id => data.products[id]).filter(isDefined),
  });
};
